export enum TierName {
  free = "free",
  teams = "teams",
  enterprise = "enterprise",
}

export class Tier {
  get isTeams(): boolean {
    return this.tierName === TierName.teams;
  }

  constructor(public tierName = TierName.free) {}
}
